// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto';
import Vue from 'vue';
import * as App from './app';
import * as fastclick from 'fastclick';

/**
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});**/

require('babel-polyfill');

fastclick.attach(document.body);

require('./bootstrap');

new Vue(App).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js